import { CSSObject } from '@mui/material';

export const multilineEllipsisOverflow = (lineClamp = 1) =>
  ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-line',
    display: '-webkit-box',
    WebkitLineClamp: lineClamp,
    WebkitBoxOrient: 'vertical',
  } as CSSObject);
